import PersonAvatar from "@common-components/tasks/person-avatar/person-avatar";
import { ToggleButton } from "@mui/material";
import { NullableId } from "@common/types/interface";
import { useAppDispatch, useAppSelector } from "@common-reducers/hooks/store.hook";
import { isRatingColumn, toggleFilterItemThunk } from "@common/reducers/TasksFilterPanelThunks";
import { isTempId } from "@common-reducers/DBServiceThunks";
import { userDisplayName } from "@common-models/user";
import { getAssignedUserListToTasks } from "@common-reducers/TaskSelectors";

type ColumnOptionInUse = {
    id?: string;
    name?: string;
    viewFilterId?: NullableId;
    isPerson?: boolean;
    bgColor?: string;
    count?: number;
    [key: string]: unknown;
};

type QuickFilterOptionButtonProps = {
    columnOptionInUse: ColumnOptionInUse;
    columnId: NullableId;
};

export const QuickFilterOptionButton = ({ columnOptionInUse, columnId }: QuickFilterOptionButtonProps) => {
    const dispatch = useAppDispatch()
    const currentAssignedMemberList = useAppSelector(getAssignedUserListToTasks);
    const person = currentAssignedMemberList.find(member => columnOptionInUse.id === member._id)
    function toggleFilterItem(id: string | undefined, name: string | undefined, columnId: NullableId, viewFilterId: string | undefined) {
        dispatch(toggleFilterItemThunk({ id, name, columnId, viewFilterId }))
    }
    const ratingColumn = useAppSelector((state) => isRatingColumn(state, columnId));
    return (
        <ToggleButton
            key={columnOptionInUse?.id || columnOptionInUse?.name}
            value="check"
            disabled={isTempId(columnOptionInUse.viewFilterId ?? null)}
            selected={!!columnOptionInUse.viewFilterId}
            onChange={
                () => toggleFilterItem(
                    columnOptionInUse?.id,
                    columnOptionInUse?.name,
                    columnId,
                    columnOptionInUse?.viewFilterId ?? undefined
                )}
            sx={{ maxWidth: '120px',borderColor:"var(--bulk-border)", fontSize: '12px', display: 'flex', justifyContent: 'space-between', textTransform: 'unset', "&.Mui-selected":{
                background:"#64e1ff87",border:"1px solid var(--color-surface)"
            } }}
        >
            {
                columnOptionInUse?.isPerson && person?.profile && (
                    <span style={{ marginInlineEnd: '6px' }}>
                        <PersonAvatar
                            size={16}
                            email={person?.email}
                            profileImg={person?.profile?.profileImg}
                            lastName={person?.profile?.lastName}
                            firstName={person?.profile?.firstName}
                           
                        />
                    </span>
                )
            }
            {columnOptionInUse?.isPerson && !person?.profile && (<PersonAvatar size={16} email={person?.email} style={{ fontSize: "14px", marginInlineEnd: '6px' }} />)}
            {
                columnOptionInUse?.bgColor && (
                    <div style={{
                        backgroundColor: columnOptionInUse?.bgColor,
                        borderRadius: '50%',
                        width: '5px',
                        height: '5px',
                        marginInlineEnd: '6px'
                    }}>

                    </div>
                )}
            <div style={{
                textOverflow: 'ellipsis',
                maxWidth: '80px',
                whiteSpace: 'nowrap',
                overflow: 'hidden'
            }} key={person?._id}>
                {columnOptionInUse.isPerson && person?.profile &&
                    <>
                        {userDisplayName(person.profile)}
                    </>
                }
                {!columnOptionInUse.isPerson && <>
                    {columnOptionInUse?.name ? `${columnOptionInUse.name} ${ratingColumn ? 'stars' : ''}` : 'Blank'}

                </>
                }
            </div>
            <div>{columnOptionInUse?.count ?? '0'}</div>
        </ToggleButton>


    )
}
